// extracted by mini-css-extract-plugin
export var legendIndicator = "_8b-1";
export var legendRight = "_8b-0";